<template>
  <div class="container">
    <meeting-room-setting-form
      :items="rooms"
      @save="saveRooms"
    />
  </div>
</template>

<script>
import MeetingRoomSettingForm from '../../SmartScheduling/components/MeetingRoomSettingForm.vue'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    MeetingRoomSettingForm,
  },
  data: () => ({
    meetingRoomSettings: [],
  }),
  computed: {
    ...mapState('auth', [
      'uid'
    ]),
    ...mapState('scheduling', [
      'rooms'
    ])
  },
  methods: {
    ...mapActions('scheduling', [
      'loadRooms'
    ]),
    saveRooms (data) {
      this.$emit('updateRooms', data)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
